import { FeatureFlags } from '../../types/Global'
import { AutomatedSections } from './types/AutomatedExperience'

export function shouldUseAutomatedExperience(
  matchingSection: AutomatedSections,
  featureFlags?: FeatureFlags
): boolean {
  return matchingSection.featureFlagKey
    ? featureFlags?.[matchingSection.featureFlagKey] === 'true'
    : true
}
